<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Confirm deletion'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        {{'Are you sure you want to delete selected menu?'|translate}}
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close('confirm-cancel')"
                aria-label="Confirm">
            {{'Confirm'|translate}}
        </button>

    </div>
</div>
